import { AfterViewInit, Directive, EventEmitter, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NgScrollbar } from 'ngx-scrollbar';
import {
	debounceTime,
	distinctUntilChanged,
	filter,
	map,
	shareReplay,
	switchMapTo,
	take,
} from 'rxjs/operators';

@UntilDestroy()
@Directive({
	selector: 'ng-scrollbar[infiniteScroll]',
})
export class InfiniteScrollDirective implements AfterViewInit {
	@Output() public reached = new EventEmitter<void>();

	constructor(private _scrollbar: NgScrollbar) {}

	ngAfterViewInit(): void {
		const scrollbarRef$ = this._scrollbar.scrolled.pipe(
			map((e) => e.target as HTMLElement),
			shareReplay({
				bufferSize: 1,
				refCount: true,
			})
		);

		scrollbarRef$
			.pipe(
				map((e) => e.scrollHeight),
				distinctUntilChanged(),
				debounceTime(500),
				switchMapTo(
					scrollbarRef$.pipe(
						map((e) => ((e.scrollTop + e.clientHeight) / e.scrollHeight) * 100),
						filter((percent) => percent >= 90),
						take(1)
					)
				),
				untilDestroyed(this)
			)
			.subscribe(() => this.reached.emit());
	}
}
